(function($) {

	$.fn.convertURLs = function() {

		if (this.is(":not(.converted)")) {

			var old_html = new_html = this.html();
			var video_regexp = /(http:\/\/|https:\/\/|)(player.|www.)?(youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/g;

			old_html.replace(video_regexp, function(match, g1, g2, g3, g4, g5, video_id) {
				var video_embed = "<div class='user-embedded-video'><iframe id='ytplayer' type='text/html' src='https://www.youtube.com/embed/" + video_id + "?autoplay=0' allowfullscreen frameborder='0'></iframe></div>";
				new_html = new_html.replace(match, video_embed);
			});

			var image_regexp = /\b(https?:\/\/\S*?\.(?:png|jpe?g|gif)(?:\?(?:(?:(?:[\w_-]+=[\w_-]+)(?:&[\w_-]+=[\w_-]+)*)|(?:[\w_-]+)))?)\b/;

			var match = old_html.match(image_regexp);

			old_html.replace(image_regexp, function(match) {
				var image_embed = "<div class='user-embedded-image'><img src='" + match + "'></div>";
				new_html = new_html.replace(match, image_embed);
			});
		
			this.addClass("converted").html(new_html);

		}

		return this;

	};

}(jQuery));

$(function() {

	$('.lazy').Lazy();

    $('button.toggle-menu').click(function() {
		$("main").toggleClass("show-menu");
    });
	/* KÃÂ¤ydÃÂ¤ÃÂ¤n lÃÂ¤pi viitteet */

	var references = [];

	$("article sup").each(function() {

		var note = $(this).text();
		var match = note.match(/^[\(\[](\d+)\s?[\)\]\s?]\s?$/); // Onko (123) tai [123]

		if (match) {
			var number = match[1];
			$(this).replaceWith("<sup class='note'><a id='note-" + number + "' href='#reference-" + number + "'>" + number + "</a></sup>");
			references.push(number);
		}

	});

	var $references = $("#references");

	if ($references) {

		var lines = $references.text().split("\n");
		var list = [];
		
		$.each(lines, function(index, line) {
			var match = line.match(/^(\d+)\.[ \t](.*)$/);

			if (match) {
				var number = match[1];
				var reference = match[2];

				if ($.inArray(number, references) > -1) {
					$("#note-" + number).attr("title", reference).tooltip();
					reference = "<a id='reference-" + number + "' href='#note-" + number + "'>" + reference + "</a>";
				}

				list.push("<li value='" + number + "'>" + reference + "</li>");
			}

		});

		$references.html("<ol>" + list.join("") + "</ol>");

	}

});



function getScrollbarWidth() {

    var $outer = $('<div>').css({visibility: 'hidden', width: 100, overflow: 'scroll'}).appendTo('body'), widthWithScroll = $('<div>').css({width: '100%'}).appendTo($outer).outerWidth();
    $outer.remove();

    return 100 - widthWithScroll;

} // getScrollbarWidth

(function(document, history, location) {
	var HISTORY_SUPPORT = !!(history && history.pushState);

	var anchorScrolls = {
		ANCHOR_REGEX: /^#[^ ]+$/,
		OFFSET_HEIGHT_PX: 80,

		init: function() {
			this.scrollToCurrent();
			$(window).on('hashchange', $.proxy(this, 'scrollToCurrent'));
			$("body").on('click', 'a', $.proxy(this, 'delegateAnchors'));
		},

		getFixedOffset: function() {
			return this.OFFSET_HEIGHT_PX;
		},

		scrollIfAnchor: function(href, pushToHistory) {
			if(!this.ANCHOR_REGEX.test(href)) return false;

			var $match = $(href);

			if ($match) {
				var anchorOffset = $match.offset().top - this.getFixedOffset();
				$('html, body').animate({ scrollTop: anchorOffset});
				$match.focus();

				if(HISTORY_SUPPORT && pushToHistory) history.pushState({}, document.title, location.pathname + href);
			}

			return !!$match;
		},

		scrollToCurrent: function(e) { 
			if(this.scrollIfAnchor(window.location.hash) && e) e.preventDefault();
		},

		delegateAnchors: function(e) {
			var elem = e.target;
			if(this.scrollIfAnchor(elem.getAttribute('href'), true)) e.preventDefault();
		}
	};

	$(document).ready($.proxy(anchorScrolls, 'init'));

})(window.document, window.history, window.location);